import { RecoilState, atom, selector, useRecoilValue } from "recoil";

import { Page, fetchFromContentful } from "@trailhead/contentful";
import { languageState } from "@trailhead/mx-context";

export const homepageVersionState: RecoilState<string | undefined> = atom({
    key: "homepageVersion",
    default: undefined as string | undefined,
});

export const homepageState = selector({
    key: "homepage",
    get: async ({ get }) => {
        const locale = get(languageState);
        const homepageVersion = get(homepageVersionState);

        if (homepageVersion?.length) {
            const contentfulResult = await fetchFromContentful<Page>({
                queryKey: [
                    "contentful",
                    {

                        content_type: "page",
                        "fields.entryName": homepageVersion,
                        limit: 1000,
                        locale: locale || "",
                    }
                ]
            });

            return contentfulResult.items?.length >= 0 ? contentfulResult.items[0] : null;
        }

        return undefined;
    },
});

export const useHomepage = () => useRecoilValue(homepageState);